














































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { TechnicalReportData } from "@/entities";
import { AppConstants as _app } from "@/shared/app.constants";
// import { Utilities as utils } from "@/shared/utilities";

const namespace: string = "technicalReport";
@Component({
  components: {}
})
export default class ActivityRowComponent extends Vue {
  @State(namespace) technicalReport!: TechnicalReportData;
  @Prop() model: any;
  @Prop() result: any;
  @Prop() resIndex: any;
  @Prop() deliverable: any;
  @Prop() activity: any;
  @Prop() delIndex: any;
  @Prop() actIndex: any;
  @Prop() forecastPeriod: any;
  @Prop() props: any;
  @Prop() formOptions: any;

  /** input event */
  showInput(e) {
    this.$emit("input", true);
  }

  getFeedbackHeader(rowKey) {
    if (this.formOptions && this.formOptions.feedbacks) {
      return this.formOptions.feedbacks.find(x => x.RowKey === rowKey);
    } else {
        return null;
    }
  }
}
